import React from 'react'
import { Modal, Button, Input, Space, message } from 'antd'
import { CopyOutlined, TabletOutlined } from '@ant-design/icons'
import Hint from './common/Hint'

/**
 * 同意書「免登入簽署連結」（2026-10-12）
 *
 * 店家在後台建的預約，客人常常沒有美感帳號、沒綁 LINE、也沒留 Email，
 * 系統通知一則都送不出去（以前重發還會顯示「已重新發送」）。
 * 這個連結不用登入就能簽、只對這一份有效：
 *   - 複製連結 → 店家貼到自己的 LINE／簡訊傳給客人
 *   - 在此裝置開啟 → 店內平板／手機直接給客人現場簽
 *
 * props:
 *   open, url, onClose
 *   undelivered  true＝剛剛重發其實沒送到，要先講清楚
 */
const ConsentSignLinkModal = ({ open, url, undelivered = false, onClose }) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      message.success('已複製簽署連結')
    } catch (_) {
      // 舊瀏覽器或非 https 時 clipboard 不能用：選取文字讓店家自己複製
      const el = document.getElementById('consent-sign-link-input')
      el?.select?.()
      message.info('請長按或按 Ctrl+C 複製連結')
    }
  }

  return (
    <Modal
      open={open}
      title='簽署連結'
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      {undelivered ? (
        <Hint tone='warning' title='系統沒有送達這位客人' style={{ marginBottom: 14 }}>
          這位客人沒有綁定 LINE／美感帳號，也沒有留 Email，系統無法自動通知。
          請把下面的連結傳給客人，或直接在店內開啟讓客人簽署。
        </Hint>
      ) : (
        <p style={{ marginTop: 0, color: '#6b6b70', fontSize: 13.5 }}>
          客人不用登入就能用這個連結簽署，只對這一份同意書有效。
        </p>
      )}
      <Input
        id='consent-sign-link-input'
        value={url}
        readOnly
        onFocus={(e) => e.target.select()}
        style={{ marginBottom: 14 }}
      />
      <Space wrap>
        <Button type='primary' icon={<CopyOutlined />} onClick={copy}>
          複製連結
        </Button>
        <Button
          icon={<TabletOutlined />}
          onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
        >
          在此裝置開啟（現場簽）
        </Button>
      </Space>
    </Modal>
  )
}

export default ConsentSignLinkModal
